import { render, staticRenderFns } from "./komisaris.vue?vue&type=template&id=0c764d8c&scoped=true&"
import script from "./komisaris.vue?vue&type=script&lang=js&"
export * from "./komisaris.vue?vue&type=script&lang=js&"
import style0 from "./komisaris.vue?vue&type=style&index=0&id=0c764d8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c764d8c",
  null
  
)

export default component.exports